import { connect } from 'react-redux';
import { default as MarketDashboardRoot } from './MarketDashboard';
import {
  getMarkers,
  getGraphData,
  getReviewStream,
  getSearch,
  searchChange,
  getUserInfo,
  // getBookingChanges,
  getTailoredRegionMarkers,
  getOTAMarkers,
  getCompsetListingIdsLoadStart,
  setCompsetListingIds,
  setListings,
  setOTAListings,
  setCurrency,
  setSearchLimitAlertBox,
  getBookingData,
  getHighLowRevPotentialInvestment,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  setBoundsMapInsights,
  setFiltersInsights,
  setFilterInsightsActive,
  setIndividualRevenuePotentialRange,
  getCachedSearchMarkets,
} from 'src/store/Dashboard/actions';
import { registerThunk, getTokenThunk } from 'src/store/Auth/actions';

const mapStateToProps = ({ dashboard }) => ({
  listings: dashboard.listings,
  otaListings: dashboard.otaListings,
  multipleMarkersCallLoading: dashboard.multipleMarkersCallLoading,
  multipleOTAMarkersCallLoading: dashboard.multipleOTAMarkersCallLoading,
  tailoredRegionMarkers: dashboard.tailoredRegionMarkers,
  graph: dashboard.graph,
  reviewStream: dashboard.reviewStream,
  bookingChanges: dashboard.bookingChanges,
  filteredBookings: dashboard.filteredBookings,
  search: dashboard.search,
  compsets: dashboard.compsets,
  compset: dashboard.compset,
  compsetListingIDs: dashboard.compsetListingIDs,
  user: dashboard.user,
  isUserAllowed: dashboard.isUserAllowed,
  currency: dashboard.currency,
  searchLimitAlertBox: dashboard.searchLimitAlertBox,
  bookingData: dashboard.bookingData,
  multipleBookingMarkersCallLoading: dashboard.multipleBookingMarkersCallLoading,
  nearbyRecommendedMarkets: dashboard.nearbyRecommendedMarkets,
  revPotentialRangeInvestment: dashboard.revPotentialRangeInvestment,
  priceTiers: dashboard.priceTiers,
  googleAutocompleteSessionToken: dashboard.googleAutocompleteSessionToken,
  googleAutocompleteSessionTokenTimeStamp: dashboard.googleAutocompleteSessionTokenTimeStamp,
  boundsMapInsights: dashboard.boundsMapInsights,
  filtersInsights: dashboard.filtersInsights,
  userCountryCode: dashboard.userCountryCode,
  cachedSearchMarkets: dashboard.cachedSearchMarkets,
  cachedMarketData: dashboard.cachedMarketData,
  filteredListingsDashboard: dashboard.filteredListingsDashboard,
});

export const MarketDashboard = connect(mapStateToProps, {
  setListings,
  setOTAListings,
  getMarkers,
  getGraphData,
  getReviewStream,
  getSearch,
  registerThunk,
  getTokenThunk,
  searchChange,
  getUserInfo,
  // getBookingChanges,
  getTailoredRegionMarkers,
  getOTAMarkers,
  getCompsetListingIdsLoadStart,
  setCompsetListingIds,
  setCurrency,
  setSearchLimitAlertBox,
  getBookingData,
  getHighLowRevPotentialInvestment,
  getGoogleAutocompleteSessionToken,
  clearGoogleAutocompleteSessionToken,
  setBoundsMapInsights,
  setFiltersInsights,
  setFilterInsightsActive,
  setIndividualRevenuePotentialRange,
  getCachedSearchMarkets,
})(MarketDashboardRoot);
